import api from "@/api/RepositoryFactory.js";
/* eslint-disable */
const state = () => ({
    surveysList: {
        data: [],
        page: {
            current: 0,
            size: 10
        },
    },
    mytargetCampaigns: [],
});

const getters = {
    getSurveysList: (state) => {
        return state.surveysList;
    },
    getMytargetCampaigns: (state) => {
        return state.mytargetCampaigns;
    },
};

const actions = {
    async fetchSurveysList({ commit, state }) {
        try {
            const resp = await api.list.getSurveysList(state.surveysList.page);
            commit("SET_SURVEYS_LIST", resp.data.result);
        } catch (e) {
            console.log(e);
        }
    },
    async fetchMytargetCampaigns({ commit }) {
        try {
            const resp = await api.list.getMytargetCampaigns();
            commit("SET_MYTARGET_CAMPAIGNS", resp.data.result.data.campaigns);
        } catch (e) {
            console.log(e);
        }
    },
    async fetchUpdatedSurveysList({commit, state}) {
        try {
            const resp = await api.list.getUpdatedSurveysList(state.surveysList.page);
            commit("SET_UPDATED_SURVEYS_LIST", resp.data.result);
        } catch (e) {
            console.log(e);
        }
    },
};

const mutations = {
    SET_SURVEYS_LIST(state, payload) {
        state.surveysList.data.push(...payload.data);
        state.surveysList.page = payload.page;
    },
    SET_UPDATED_SURVEYS_LIST(state, payload) {
        state.surveysList.data = payload.data;
    },
    SET_MYTARGET_CAMPAIGNS(state, data) {
        state.mytargetCampaigns = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
